import { render, staticRenderFns } from "./psGoodItemTop.vue?vue&type=template&id=1ff6f071&scoped=true&"
import script from "./psGoodItemTop.vue?vue&type=script&lang=js&"
export * from "./psGoodItemTop.vue?vue&type=script&lang=js&"
import style0 from "./psGoodItemTop.vue?vue&type=style&index=0&id=1ff6f071&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff6f071",
  null
  
)

export default component.exports